import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-dear.mjs";
import { render } from "lit-html";
import {
    B,
    getCircle,
    getKiittiSummary,
    TOKENS,
    getKiitosSummary,
    getTipAmount,
    getTipAmount2,
    getTipAmount3,
    downloadFile,
    getAuraRing,
    getAuraName,
    getRandomNumber,
    REWARD_SHARE
} from "../../global.ts";
import { User, Moment, Kiitti } from "../../../models/Kiitti.ts";
import { Me } from "../../../managers/Me.ts";
import { Media } from "../../../managers/Media.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";
import { HbMain } from "../hb-main.ts";
import Dear from "./dear.json";

//import Strings from "../../../models/Strings.json";
//const strings: any = Strings;
const hb = new URL("../../../public/hb.svg", import.meta.url).href;

import Stock from "./Treasury.json";
const stock: { category: string; folder: string; count: number }[] = Stock;
const dear: { name: string; hashtag: string }[] = Dear;

export class HbDear extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private me = new Me();
    private media = new Media();
    private kiitti = new Kiitti();
    private modal: ModalInterface;
    private main = document.querySelector("hb-main") as HbMain;

    private dear: HTMLElement;
    private form: HTMLFormElement;
    private archive: HTMLButtonElement;
    private quest: HTMLButtonElement;
    private cover: HTMLVideoElement;
    private views: HTMLSpanElement;
    private location: HTMLButtonElement;

    private privacy: HTMLElement;
    private publicBtn: HTMLButtonElement;
    private privateBtn: HTMLButtonElement;
    private party: HTMLElement;
    private life: HTMLSpanElement;
    private user: HTMLSpanElement;
    private arrow: HTMLSpanElement;
    private arrowBtn: SVGElement;

    private checkinForm: HTMLElement;
    private checkinCrews: HTMLSelectElement;
    private checkinOrgs: HTMLSelectElement;
    private checkinReset: HTMLButtonElement;
    //private cachedLocation = ""; // redundant

    private menu: HTMLElement;

    private photo: HTMLElement;
    private photoBtn: HTMLButtonElement;
    private photoFile: HTMLInputElement;
    private photoProgress: HTMLElement;
    private photoUpload: HTMLElement;
    private photoImageContainer: HTMLElement;
    private photoImage: HTMLImageElement;
    private photoRemove: HTMLButtonElement;
    private photoDownload: HTMLButtonElement;

    private short: HTMLElement;
    private shortBtn: HTMLButtonElement;
    private shortFile: HTMLInputElement;
    private shortProgress: HTMLElement;
    private shortUpload: HTMLElement;
    private shortVideoContainer: HTMLElement;
    private shortVideo: HTMLVideoElement;
    private shortRemove: HTMLButtonElement;
    private shortDownload: HTMLButtonElement;

    private heroes: HTMLElement;
    private gold: HTMLTextAreaElement;
    private goldMenu: HTMLLabelElement;
    private goldLabel: HTMLLabelElement;
    private goldKarat: HTMLSpanElement;
    private goldCarat: HTMLSpanElement;
    private goldKiitti: HTMLSpanElement;
    private goldKiitos: HTMLSpanElement;
    private goldGratuity: HTMLSpanElement;
    private magic: HTMLButtonElement;
    private copy: HTMLButtonElement;
    private paste: HTMLButtonElement;
    private trash: HTMLButtonElement;

    private footer: HTMLElement;
    private footerDate: HTMLParagraphElement;
    private rethanks: HTMLSpanElement;
    private footerRecommended: HTMLElement;
    private footerKiitti: HTMLSpanElement;
    private footerTotal: HTMLSpanElement;

    private internalBtns: HTMLElement;
    private captureBtn: HTMLButtonElement;
    private captureNewBtn: HTMLButtonElement;
    private externalBtns: HTMLElement;
    private shareBtn: HTMLButtonElement;
    private copyBtn: HTMLButtonElement;
    private thankBtns: HTMLElement;
    private tokenBtns: HTMLElement;

    private hasPasskey = false;
    private thank: Moment | null = null;
    private jewel: "photo" | "short" = "short";

    private isQuest = false;
    private isSelf = true; // deprecated
    private isPrivate = false;
    private selectedMention = "";
    private selectedHashTag = "";
    private isLoading = false;
    private lastTapTime: number = 0;

    constructor() {
        super();
        render(template(null), this);

        this.dear = this.querySelector("#hb-dear")!;
        this.form = this.querySelector("#hb-dear-form")!;
        this.archive = this.querySelector("#hb-dear-archive")!;
        this.quest = this.querySelector("#hb-dear-quest")!;
        this.cover = this.querySelector("#hb-dear-cover")!;
        this.views = this.querySelector("#hb-dear-views")!;
        this.location = this.querySelector("#hb-dear-location")!;

        this.privacy = this.querySelector("#hb-dear-privacy")!;
        this.privateBtn = this.querySelector("#hb-dear-private")!;
        this.publicBtn = this.querySelector("#hb-dear-public")!;
        this.party = this.querySelector("#hb-dear-party")!;
        this.life = this.querySelector("#hb-dear-party-life")!;
        this.user = this.querySelector("#hb-dear-party-user")!;
        this.arrow = this.querySelector("#hb-dear-party-arrow")!;
        this.arrowBtn = this.querySelector("#hb-dear-party-button")!;

        this.checkinForm = this.querySelector("#hb-dear-checkin-form")!;
        this.checkinCrews = this.querySelector("#hb-dear-checkin-crews")!;
        this.checkinOrgs = this.querySelector("#hb-dear-checkin-orgs")!;
        this.checkinReset = this.querySelector("#hb-dear-checkin-reset")!;

        this.menu = this.querySelector("#hb-dear-menu")!;

        this.photo = this.querySelector("#hb-dear-photo")!;
        this.photoBtn = this.querySelector("#hb-dear-menu-photo")!;
        this.photoFile = this.querySelector("#hb-dear-photo-file")!;
        this.photoProgress = this.querySelector("#hb-dear-photo-progress")!;
        this.photoUpload = this.querySelector("#hb-dear-photo-upload")!;
        this.photoImage = this.querySelector("#hb-dear-photo-image")!;
        this.photoRemove = this.querySelector("#hb-dear-photo-remove")!;
        this.photoImageContainer = this.photoImage.parentElement as HTMLElement;
        this.photoDownload = this.querySelector("#hb-dear-photo-download")!;

        this.short = this.querySelector("#hb-dear-short")!;
        this.shortBtn = this.querySelector("#hb-dear-menu-short")!;
        this.shortFile = this.querySelector("#hb-dear-short-file")!;
        this.shortProgress = this.querySelector("#hb-dear-short-progress")!;
        this.shortUpload = this.querySelector("#hb-dear-short-upload")!;
        this.shortVideo = this.querySelector("#hb-dear-short-video")!;
        this.shortRemove = this.querySelector("#hb-dear-short-remove")!;
        this.shortVideoContainer = this.shortVideo.parentElement as HTMLElement;
        this.shortDownload = this.querySelector("#hb-dear-short-download")!;

        this.heroes = this.querySelector("#hb-dear-heroes")!;
        this.gold = this.querySelector("#hb-dear-gold")!;
        this.goldMenu = this.querySelector("#hb-dear-gold-menu")!;
        this.goldLabel = this.querySelector("#hb-dear-gold-label")!;
        this.goldKarat = this.querySelector("#hb-dear-gold-karat")!;
        this.goldCarat = this.querySelector("#hb-dear-gold-carat")!;
        this.goldKiitti = this.querySelector("#hb-dear-gold-kiitti")!;
        this.goldKiitos = this.querySelector("#hb-dear-gold-kiitos")!;
        this.goldGratuity = this.querySelector("#hb-dear-gold-gratuity")!;
        this.magic = this.querySelector("#hb-dear-gold-magic")!;
        this.copy = this.querySelector("#hb-dear-gold-copy")!;
        this.paste = this.querySelector("#hb-dear-gold-paste")!;
        this.trash = this.querySelector("#hb-dear-gold-trash")!;

        this.footer = this.querySelector("#hb-dear-footer")!;
        this.footerDate = this.querySelector("#hb-dear-footer-date")!;
        this.rethanks = this.querySelector("#hb-dear-footer-rethanks")!;
        this.footerRecommended = this.querySelector("#hb-dear-kiitti")!;
        this.footerKiitti = this.querySelector("#hb-dear-kiitti-recommended")!;
        this.footerTotal = this.querySelector("#hb-dear-kiitti-total")!;

        this.internalBtns = this.querySelector("#hb-dear-internal")!;
        this.captureBtn = this.internalBtns
            .firstElementChild as HTMLButtonElement;
        this.captureNewBtn = this.internalBtns
            .lastElementChild as HTMLButtonElement;
        this.externalBtns = this.querySelector("#hb-dear-external")!;
        this.shareBtn = this.querySelector("#hb-dear-share")!;
        this.copyBtn = this.querySelector("#hb-dear-copy")!;
        this.thankBtns = this.querySelector("#hb-dear-thanks")!;
        this.tokenBtns = this.querySelector("#hb-dear-tokens")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: false,
            onHide: () => {
                this.cover.muted = true;
                this.shortVideo.muted = true;
                //window.location.hash = "#";
            },
            onShow: () => {
                // need user interaction
                //if (this.stockImage.paused) this.stockImage.play();
                //if (this.aiImage.paused) this.aiImage.play();
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-dear",
            override: true
        };

        this.modal = new Modal(this.dear, modalOptions, instanceOptions);
    }

    private addDoubleTapListener() {
        const el = this.cover.parentElement as HTMLElement;
        if (!el) return;

        el.addEventListener("touchend", (e: TouchEvent) => {
            const currentTime = new Date().getTime();
            const tapDelay = currentTime - this.lastTapTime;

            // 300ms is the standard threshold for a double tap
            if (tapDelay < 300 && tapDelay > 0) {
                this.handleDoubleTap(e);
            }

            this.lastTapTime = currentTime;
        });
    }

    private addSwipeListeners() {
        const el = this.cover.parentElement as HTMLElement;
        if (!el) return;

        let touchStartX = 0;
        let touchEndX = 0;

        // 1. Capture the start of the touch
        el.addEventListener(
            "touchstart",
            (e: TouchEvent) => {
                touchStartX = e.changedTouches[0].screenX;
            },
            { passive: true }
        );

        // 2. Capture the end and calculate the delta
        el.addEventListener(
            "touchend",
            (e: TouchEvent) => {
                touchEndX = e.changedTouches[0].screenX;
                this.handleSwipeGesture(touchStartX, touchEndX);
            },
            { passive: true }
        );
    }

    private showLoading(isLoading: boolean) {
        if (isLoading) {
            this.isLoading = true;
            this.main.showSpinner();
        } else {
            this.isLoading = false;
            this.main.hideSpinner();
        }
    }

    private async handleDoubleTap(e: TouchEvent) {
        const el = e.currentTarget as HTMLElement;
        const rect = el.getBoundingClientRect();
        const touchX = e.changedTouches[0].clientX - rect.left; // X position relative to element
        const midPoint = rect.width / 2;

        if (touchX > midPoint) {
            console.log("Double tapped on the RIGHT");
        } else {
            console.log("Double tapped on the LEFT");
        }

        if (this.isLoading || !this.thank) return;
        this.showLoading(true);
        const moment = await this.kiitti.getRandom(
            this.heartbank.user?.uid || ""
        );
        this.showLoading(false);

        if (moment) {
            history.pushState(null, "", `#/aquarius/${moment.id}/boost`);
            await this.show(moment, true);
            //window.location.hash = `#/aquarius/${moment.id}/boost`;
        } else alert("There are no more B-Moments of Kindness");
    }

    private async handleSwipeGesture(startX: number, endX: number) {
        const threshold = 50; // Minimum pixels to count as a swipe
        const delta = endX - startX;

        // If movement is too small, ignore it
        if (this.isLoading || !this.thank || Math.abs(delta) < threshold)
            return;
        // Swipe Right (Positive delta) vs Swipe Left (Negative delta)
        const direction = delta > 0 ? "next" : "prev";

        this.showLoading(true);
        const moment = await this.kiitti.getRock(
            this.thank.user,
            window.momentCursor,
            direction
        );
        if (moment.cursor) window.momentCursor = moment.cursor; // redundant but keep for now
        this.showLoading(false);

        if (moment.data) {
            history.pushState(null, "", `#/aquarius/${moment.data.id}`);
            await this.show(moment.data, false);
            //window.location.hash = `#/aquarius/${moment.data.id}`;
        } else {
            // const label = direction === "prev" ? "New" : "Old";
            // alert(
            //     `There are no more ${label} B-Moments of Kindness`
            // );
            alert("You have reached the end");
        }
    }

    connectedCallback() {
        this.addPhotoListeners();
        this.addShortListeners();
        this.addGoldListeners();
        this.addFooterListeners();
        this.addDoubleTapListener();
        this.addSwipeListeners();

        this.archive.addEventListener("click", () =>
            alert("B-Album coming soon!")
        );

        this.checkinReset.addEventListener(
            "click",
            async () => await this.renderCheckin(true)
        );

        this.privateBtn.addEventListener("click", () => {
            this.isPrivate = true;
            this.privateBtn.classList.add("underline", "uppercase");
            this.publicBtn.classList.remove("underline", "uppercase");
            this.renderGold();
        });

        this.publicBtn.addEventListener("click", () => {
            this.isPrivate = false;
            this.privateBtn.classList.remove("underline", "uppercase");
            this.publicBtn.classList.add("underline", "uppercase");
            this.renderGold();
        });

        ["click", "change"].forEach((event) => {
            this.checkinCrews.addEventListener(event, () => {
                const radio = this.querySelector(
                    "input[value=crew]"
                ) as HTMLInputElement;
                radio.checked = true;
            });
        });

        ["click", "change"].forEach((event) => {
            this.checkinOrgs.addEventListener(event, () => {
                const radio = this.querySelector(
                    "input[value=org]"
                ) as HTMLInputElement;
                radio.checked = true;
            });
        });

        this.user.addEventListener("click", async () => {
            const profile = await this.me.getUserProfile(
                this.thank?.user || this.heartbank.user?.uid!
            );
            const name = this.me.getName2(profile);
            const [sign, karat] = profile.kiitti?.numberTuple() || ["", "Zero"];
            if (
                confirm(
                    `${getAuraRing(profile.kiittiFrequency || 0, false)} ${name}'s current Kiitti Aura is ${getAuraName(profile.kiittiFrequency || 0)}\n\n${getCircle(profile.kiitti || 0, false)} ${name}'s current Kiitti Balance is ${sign + karat} ${getKiittiSummary(
                        profile.kiitti || 0,
                        name
                    )}\n\nWould you like to watch ${name}'s B-Shorts?`
                )
            )
                window.open("https://id.333.eco", "_blank");
        });

        this.life.addEventListener("click", async () => {
            const kiitti = await this.kiitti.getKiitti();
            const [sign, karat] = kiitti?.numberTuple() || ["", "Zero"];
            const frequency = getRandomNumber(0, 100);
            if (
                confirm(
                    `${getAuraRing(frequency)} Miss Aquarius™'s current Aura is ${getAuraName(frequency)}\n\n${getCircle(kiitti || 0)} Miss Aquarius™'s current Kiitti Balance is ${sign + karat} ${getKiittiSummary(
                        kiitti || 0,
                        "Miss Aquarius™"
                    )}\n\nWould you like to watch Miss Aquarius™'s B-Shorts?`
                )
            )
                window.open("https://id.333.eco", "_blank");
        });

        this.arrowBtn.addEventListener("click", () => {
            this.isSelf = !this.isSelf;
            this.party.classList.toggle("flex-row-reverse");
            this.renderGold();
        });

        this.heartbank.addAuthStateListener(async (user) => {
            render(template(user), this);
            if (user)
                this.hasPasskey = (await this.heartbank.passKeysCount()) > 0;
        });

        // const close = this.querySelector("#hb-dear-close") as HTMLButtonElement;
        // close.addEventListener("click", () => (window.location.hash = "#"));
    }

    private resetMenu() {
        this.photoBtn.classList.remove("underline", "uppercase");
        this.shortBtn.classList.remove("underline", "uppercase");

        this.photo.classList.add("hidden");
        this.short.classList.add("hidden");
    }

    private addPhotoListeners() {
        this.photoBtn.addEventListener("click", () => {
            this.jewel = "photo";
            this.resetMenu();
            this.photoBtn.classList.add("underline", "uppercase");
            this.photo.classList.remove("hidden");
        });

        this.photoFile.addEventListener("change", async () => {
            if (this.heartbank.user && this.hasPasskey) {
                this.showLoading(true);
                this.photoFile.disabled = true;
                if (this.photoFile.files && this.photoFile.files.length > 0) {
                    const progress = this.photoProgress
                        .parentElement as HTMLElement;
                    this.photoProgress.style.width = "0%";
                    this.photoProgress.textContent = "0%";
                    progress.classList.remove("hidden");
                    try {
                        const photo = await this.media.createPhotoFromFile(
                            this.photoFile.files[0]
                        );
                        this.photoImage.src = await this.media.storeFile(
                            photo.name,
                            photo,
                            (percent) => {
                                this.photoProgress.style.width = percent + "%";
                                this.photoProgress.textContent = `${percent}%`; // Uploading:
                            }
                        );
                        localStorage.setItem(
                            "moment-photo",
                            this.photoImage.src
                        );
                        this.photoImageContainer.classList.remove("hidden");
                        this.photoUpload.classList.add("hidden");
                        this.renderGold();
                    } catch (error: any) {
                        alert(error.message);
                    } finally {
                        progress.classList.add("hidden");
                    }
                }
                this.photoFile.disabled = false;
                this.showLoading(false);
            } else {
                if (this.heartbank.user) {
                    if (
                        confirm(
                            "Passkey is required to capture a B-Moment of Kindness.\n\nWould you like to create one now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-lockbox",
                            window.location.hash
                        );
                        window.location.hash = "#/lockbox";
                    }
                } else {
                    if (
                        confirm(
                            "You need to be logged in to capture a B-Moment of Kindness.\n\nWould you like to log in now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-login",
                            window.location.hash
                        );
                        window.location.hash = "#/login";
                    }
                }
            }
        });

        this.photoDownload.addEventListener("click", async () => {
            this.photoDownload.disabled = true;
            await downloadFile("B-Photo", this.photoImage.src); // extension auto added
            this.photoDownload.disabled = false;
        });

        this.photoRemove.addEventListener("click", async () => {
            if (confirm("Would you like to remove this photo?")) {
                this.showLoading(true);
                this.photoRemove.disabled = true;

                await this.media.removeFile(this.photoImage.src);
                localStorage.removeItem("moment-photo");
                this.photoFile.value = "";
                this.photoImageContainer.classList.add("hidden");
                this.photoUpload.classList.remove("hidden");

                this.photoRemove.disabled = false;
                this.renderGold();
                this.showLoading(false);
            }
        });
    }

    private addShortListeners() {
        this.shortBtn.addEventListener("click", () => {
            this.jewel = "short";
            this.resetMenu();
            this.shortBtn.classList.add("underline", "uppercase");
            this.short.classList.remove("hidden");
        });

        this.shortFile.addEventListener("change", async () => {
            if (this.heartbank.user && this.hasPasskey) {
                this.showLoading(true);
                this.shortFile.disabled = true;
                if (this.shortFile.files && this.shortFile.files.length > 0) {
                    const progress = this.shortProgress
                        .parentElement as HTMLElement;
                    this.shortProgress.style.width = "0%";
                    this.shortProgress.textContent = "0%";
                    progress.classList.remove("hidden");
                    try {
                        const short = this.shortFile.files[0];
                        const result =
                            await this.media.validateVideoFile(short);
                        if (result.isValid && result.poster) {
                            this.shortVideo.poster = await this.media.storeFile(
                                result.poster.name,
                                result.poster,
                                (percent) => {
                                    this.shortProgress.style.width =
                                        percent + "%";
                                    this.shortProgress.textContent = `${percent}%`; // Uploading poster:
                                }
                            );
                            localStorage.setItem(
                                "moment-poster",
                                this.shortVideo.poster
                            );
                            this.shortVideo.src = await this.media.storeFile(
                                short.name,
                                short,
                                (percent) => {
                                    this.shortProgress.style.width =
                                        percent + "%";
                                    this.shortProgress.textContent = `${percent}%`; // Uploading video:
                                }
                            );
                            localStorage.setItem(
                                "moment-short",
                                this.shortVideo.src
                            );
                            this.shortVideoContainer.classList.remove("hidden");
                            this.shortUpload.classList.add("hidden");
                            this.renderGold();
                        } else alert(result.errorMessage);
                    } catch (error: any) {
                        alert(error.message);
                    } finally {
                        progress.classList.add("hidden");
                    }
                }
                this.shortFile.disabled = false;
                this.showLoading(false);
            } else {
                if (this.heartbank.user) {
                    if (
                        confirm(
                            "Passkey is required to capture a B-Moment of Kindness.\n\nWould you like to create one now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-lockbox",
                            window.location.hash
                        );
                        window.location.hash = "#/lockbox";
                    }
                } else {
                    if (
                        confirm(
                            "You need to be logged in to capture a B-Moment of Kindness.\n\nWould you like to log in now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-login",
                            window.location.hash
                        );
                        window.location.hash = "#/login";
                    }
                }
            }
        });

        this.shortDownload.addEventListener("click", async () => {
            this.shortDownload.disabled = true;
            await downloadFile("B-Short", this.shortVideo.src); // extension auto added
            this.shortDownload.disabled = false;
        });

        this.shortRemove.addEventListener("click", async () => {
            if (confirm("Would you like to remove this short?")) {
                this.showLoading(true);
                this.shortRemove.disabled = true;

                await this.media.removeFile(this.shortVideo.poster);
                await this.media.removeFile(this.shortVideo.src);
                localStorage.removeItem("moment-poster");
                localStorage.removeItem("moment-short");
                this.shortFile.value = "";
                this.shortVideoContainer.classList.add("hidden");
                this.shortUpload.classList.remove("hidden");

                this.shortRemove.disabled = false;
                this.renderGold();
                this.showLoading(false);
            }
        });
    }

    private renderHeroes(search: string = "") {
        this.heroes.innerHTML = "";

        if (search[0] === "@") {
            search = search.replace("@", "");
            const heroes = JSON.parse(localStorage.getItem("heroes") || "[]"); // need to wait to load all heroes

            for (const hero of heroes) {
                if (
                    search === "" ||
                    hero.displayName
                        .toLowerCase()
                        .includes(search.trim().toLowerCase()) ||
                    hero.username
                        .toLowerCase() // not needed?
                        .includes(search.trim().toLowerCase())
                ) {
                    const button = document.createElement("button");
                    button.type = "button";
                    button.innerHTML = `<hb-me class="" uid="${hero.uid}"></hb-me>`;
                    button.className = "snap-start shrink-0";
                    button.addEventListener("click", () => {
                        const pos = this.gold.selectionStart ?? 0;
                        const value = this.gold.value;

                        // find start of current token
                        let start = pos;
                        while (start > 0 && !/\s|\n/.test(value[start - 1])) {
                            start--;
                        }

                        // find end of current token (NEW)
                        let end = pos;
                        while (
                            end < value.length &&
                            !/\s|\n/.test(value[end])
                        ) {
                            end++;
                        }

                        const token = value.slice(start, end);

                        // ensure it's a hashtag
                        if (/@[a-zA-Z0-9]{0,100}$/.test(token)) {
                            const replacement = `@${hero.username}`;

                            this.gold.value =
                                value.slice(0, start) +
                                replacement +
                                value.slice(end);

                            if (this.gold.value.endsWith(replacement))
                                this.gold.value += " ";

                            // move cursor after inserted tag
                            const newPos = start + replacement.length + 1;
                            this.gold.setSelectionRange(newPos, newPos);
                        }

                        localStorage.setItem("moment-gold", this.gold.value);
                        this.gold.focus();
                    });
                    this.heroes.appendChild(button);
                    // this.heroes.append(
                    //     button.cloneNode(true),
                    //     button.cloneNode(true),
                    //     button.cloneNode(true),
                    //     button.cloneNode(true)
                    // );
                }
            }
        } else {
            search = search.replace("#", "");

            for (const item of dear) {
                if (
                    search === "" ||
                    item.name
                        .toLowerCase()
                        .includes(search.trim().toLowerCase()) ||
                    item.hashtag
                        .toLowerCase()
                        .includes(search.trim().toLowerCase())
                ) {
                    const button = document.createElement("button");
                    button.type = "button";
                    button.textContent = item.name;
                    button.className = "snap-start shrink-0";
                    button.addEventListener("click", () => {
                        const pos = this.gold.selectionStart ?? 0;
                        const value = this.gold.value;

                        // find start of current token
                        let start = pos;
                        while (start > 0 && !/\s|\n/.test(value[start - 1])) {
                            start--;
                        }

                        // find end of current token (NEW)
                        let end = pos;
                        while (
                            end < value.length &&
                            !/\s|\n/.test(value[end])
                        ) {
                            end++;
                        }

                        const token = value.slice(start, end);

                        // ensure it's a hashtag
                        if (/#[a-zA-Z0-9]{0,100}$/.test(token)) {
                            const replacement = `#${item.hashtag}`;

                            this.gold.value =
                                value.slice(0, start) +
                                replacement +
                                value.slice(end);

                            if (this.gold.value.endsWith(replacement))
                                this.gold.value += " ";

                            // move cursor after inserted tag
                            const newPos = start + replacement.length + 1;
                            this.gold.setSelectionRange(newPos, newPos);
                        }

                        localStorage.setItem("moment-gold", this.gold.value);
                        this.gold.focus();
                    });
                    this.heroes.appendChild(button);
                }
            }
        }

        return this.heroes.innerHTML !== "";
    }

    private checkHero() {
        // match mention or tag immediately before cursor
        const cursorPosition = this.gold.selectionStart ?? 0;
        const textBeforeCursor = this.gold.value.slice(0, cursorPosition);
        const match = textBeforeCursor.match(/[@#][a-zA-Z0-9]{0,100}$/);

        /**
         * Match rules:
         * (^|\s)        → start of line OR whitespace before trigger
         * [@#]          → trigger char
         * [a-zA-Z0-9]*  → tag/mention text
         * $             → must end at cursor
         */
        //const match = textBeforeCursor.match(/(^|\s)([@#][a-zA-Z0-9]{0,100})$/); // works for # but not @

        // deprecated: match at the end only
        // const match = this.gold.value
        //     //.trimEnd()
        //     .match(/[@#][a-zA-Z0-9]{0,100}$/);

        if (match && this.renderHeroes(match[0])) {
            this.heroes.classList.remove("hidden");
            this.heroes.classList.add("flex");
            this.goldMenu.classList.add("hidden");
            this.goldMenu.classList.remove("inline-flex");
        } else {
            this.heroes.classList.add("hidden");
            this.heroes.classList.remove("flex");
            this.goldMenu.classList.remove("hidden");
            this.goldMenu.classList.add("inline-flex");
        }

        this.checkKiitti();
    }

    private checkKiitti() {
        const cursorPosition = this.gold.selectionStart ?? 0;
        const textBeforeCursor = this.gold.value.slice(0, cursorPosition);
        const match = textBeforeCursor.match(/💜(\d+){0,1000000}$/);

        if (match) {
            this.footerRecommended.classList.remove("hidden");
            this.footerKiitti.textContent = this.recommendedKiitti().toString();
            this.footerTotal.textContent = this.sumKiitti(
                this.gold.value
            ).toString();
        } else {
            this.footerRecommended.classList.add("hidden");
        }
    }

    //TODO: match the backend formula
    private recommendedKiitti() {
        return this.gold.value.split(" ").length * 10;
    }

    private sumKiitti(input: string): number {
        const regex = /💜(\d+)/g;

        let total = 0;
        let match: RegExpExecArray | null;

        while ((match = regex.exec(input)) !== null) {
            total += parseInt(match[1], 10);
        }

        return total;
    }

    private addGoldListeners() {
        this.gold.addEventListener("focus", () => this.checkHero());
        this.gold.addEventListener("keyup", () => this.checkHero());
        this.gold.addEventListener("click", () => this.checkHero());
        this.gold.addEventListener("select", () => this.checkHero());
        //this.gold.addEventListener("selectionchange", () => this.checkHero());
        document.addEventListener("selectionchange", () => {
            if (document.activeElement === this.gold) this.checkHero();
        });
        // conflicts with click on hero
        // this.addEventListener("blur", () => this.checkHero());
        // this.gold.addEventListener("blur", () => {
        //     this.heroes.classList.add("hidden");
        //     this.heroes.classList.remove("flex");
        //     this.goldMenu.classList.remove("hidden");
        //     this.goldMenu.classList.add("inline-flex");
        // });

        this.gold.addEventListener("input", () => {
            this.copy.classList.toggle("hidden", !this.gold.value.trim());
            localStorage.setItem("moment-gold", this.gold.value);
            this.checkHero();
        });

        this.magic.addEventListener("click", async () => {
            if (
                this.gold.value.trim() === "" ||
                confirm(
                    `Would you like Miss Aquarius™ AI to improve your writing?`
                )
            ) {
                this.gold.value = "I'm thankful for the gift of life.";
                // this.gold.value = this.isSelf
                //     ? "I'm thankful for myself."
                //     : "I'm thankful for the gift of life.";
                localStorage.setItem("moment-gold", this.gold.value);
                this.checkHero();
                this.gold.focus();
            }
            //alert("AI writing assistant coming soon...");
        });

        this.copy.addEventListener("click", async () => {
            await navigator.clipboard.writeText(this.gold.value);
            alert("Your writing has been copied to your clipboard!");
            //this.gold.focus();
        });

        this.paste.addEventListener("click", async () => {
            if (
                this.gold.value.trim() === "" ||
                confirm(
                    "Would you like to replace your writing with the one you copied to your clipboard?"
                )
            ) {
                this.gold.value = await navigator.clipboard.readText();
                localStorage.setItem("moment-gold", this.gold.value);
                this.checkHero();
                this.copy.classList.toggle("hidden", !this.gold.value.trim());
                this.gold.focus();
            }
        });

        this.trash.addEventListener("click", () => {
            if (
                this.gold.value &&
                confirm("Would you like to clear your writing and start over?")
            ) {
                this.gold.value = "";
                localStorage.setItem("moment-gold", this.gold.value);
                this.copy.classList.toggle("hidden", !this.gold.value.trim());
                this.gold.focus();
            }
        });
    }

    private getJewel() {
        switch (this.jewel) {
            case "photo":
                return this.photoImage.src;
            case "short":
                return this.shortVideo.poster;
        }
    }

    private getDiamond() {
        switch (this.jewel) {
            case "photo":
                return "";
            case "short":
                return this.shortVideo.src;
        }
    }

    private getType() {
        switch (this.jewel) {
            case "photo":
                return localStorage.getItem("moment-photo") ? "photo" : "none";
            case "short":
                return localStorage.getItem("moment-short") ? "short" : "none"; // check moment-poster ?
        }
    }

    private async cleanUp() {
        const photo = localStorage.getItem("moment-photo");
        const poster = localStorage.getItem("moment-poster");
        const short = localStorage.getItem("moment-short");

        switch (this.jewel) {
            case "photo":
                if (poster) await this.media.removeFile(poster);
                if (short) await this.media.removeFile(short);
                break;
            case "short":
                if (photo) await this.media.removeFile(photo);
                break;
        }

        localStorage.removeItem("moment-photo");
        localStorage.removeItem("moment-poster");
        localStorage.removeItem("moment-short");
        localStorage.removeItem("moment-gold");

        this.photoImageContainer.classList.add("hidden");
        this.photoUpload.classList.remove("hidden");
        this.shortVideoContainer.classList.add("hidden");
        this.shortUpload.classList.remove("hidden");
    }

    private addFooterListeners() {
        //TODO: later finish => redirect to map ??
        this.captureBtn.addEventListener("click", async (event) => {
            event.preventDefault();
            this.showLoading(true);
            this.captureBtn.disabled = true;
            if (this.heartbank.user && this.hasPasskey) {
                const gold = this.gold.value.trim();
                if (!this.hasMedia() && gold === "") {
                    this.gold.setCustomValidity(
                        "A Kindness Note is required if no photo or short is included."
                    );
                    this.gold.reportValidity();
                } else {
                    const group = this.getKind();
                    const place =
                        group === "crew"
                            ? this.checkinCrews.options[
                                  this.checkinCrews.selectedIndex
                              ]
                            : this.checkinOrgs.options[
                                  this.checkinOrgs.selectedIndex
                              ];

                    const response = await this.kiitti.capture(
                        this.isQuest,
                        this.isSelf,
                        this.isPrivate,

                        gold,
                        this.getJewel(),
                        this.getDiamond(),
                        this.shortVideo.duration || 0,
                        this.getType(),

                        window.earth.location?.lat ||
                            window.earth.longBeach.lat,
                        window.earth.location?.lng ||
                            window.earth.longBeach.lng,

                        parseFloat(place.dataset.lat!),
                        parseFloat(place.dataset.lng!),
                        place.dataset.address ||
                            place.dataset.region + ", " + place.dataset.country,
                        place.text,
                        group
                        //place.value; //TODO: later gid
                    );
                    if (response.data) {
                        await this.cleanUp();
                        this.alertSuccess(
                            response.data.kiitti,
                            response.data.aquaBalance || 0,
                            response.data.minter,
                            response.data.users,
                            response.data.hashtags
                        );

                        const event = new CustomEvent("hb-treasury", {
                            detail: {
                                isShow: false
                            },
                            bubbles: true,
                            composed: true
                        });
                        this.dispatchEvent(event);

                        window.location.hash = `#/aquarius/${response.data.id}`;
                    } else if (response.color === "red") alert(response.text);
                }
            } else {
                if (this.heartbank.user) {
                    if (
                        confirm(
                            "Passkey is required to capture a B-Moment of Kindness.\n\nWould you like to create one now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-lockbox",
                            window.location.hash
                        );
                        window.location.hash = "#/lockbox";
                    }
                } else {
                    if (
                        confirm(
                            "You need to be logged in to capture a B-Moment of Kindness.\n\nWould you like to log in now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-login",
                            window.location.hash
                        );
                        window.location.hash = "#/login";
                    }
                }
            }
            this.captureBtn.disabled = false;
            this.showLoading(false);
        });

        //this.form.addEventListener("submit", this.share.bind(this));
        this.shareBtn.addEventListener("click", this.share.bind(this));

        this.copyBtn.addEventListener("click", async (event) => {
            try {
                // We wrap the async call in a Promise that returns a Blob
                const clipboardItem = new ClipboardItem({
                    "text/plain": this.getText(false).then((text) => {
                        return new Blob([text], { type: "text/plain" });
                    })
                });

                // We write the item immediately.
                // The browser handles the "waiting" for the getText() promise internally.
                await navigator.clipboard.write([clipboardItem]);

                alert(
                    "This B-Moment of Kindness has been copied to your clipboard!"
                );
            } catch (err) {
                console.error("Clipboard move failed:", err);
                // Fallback for older browsers or permission denials
                alert(
                    "Copy failed. Please try again or ensure the site has clipboard permissions."
                );
            }
        });

        // this.copyBtn.addEventListener("click", async (event) => {
        //     await navigator.clipboard.writeText(await this.getText(false)); // cannot do link first bc weird bug
        //     alert(
        //         "This B-Moment of Kindness has been copied to your clipboard!"
        //     );
        // });
    }

    private getNames(users: Moment["users"]) {
        if (users && users.length > 0) {
            return users.length === 1 &&
                users[0].id === this.heartbank.user?.uid
                ? "Yourself"
                : users.map((user) => user.name).joinWithAnd(); //.join(", ")
        } else return ""; //Miss Aquarius™
    }

    private getName(users: Moment["users"], hashtags: Moment["hashtags"]) {
        const hasUsers = users && users.length > 0;
        const hasTags = hashtags && hashtags.length > 0;

        if (hasUsers && hasTags) {
            return "Their";
        } else if (hasUsers) {
            if (users.length === 1) {
                return users[0].id === this.heartbank.user?.uid
                    ? "Your"
                    : users[0].name + "'s";
            } else return "Their";
        } else return "Miss Aquarius™'s";
    }

    // thank
    private alertSuccess(
        kiitti: Moment["kiitti"],
        aquaBalance: Moment["aquaBalance"],
        minter: Moment["minter"],
        users: Moment["users"],
        hashtags: Moment["hashtags"]
    ) {
        const [aquaSign, aquaKarat] = aquaBalance?.numberTuple() || [
            "",
            "Zero"
        ];
        const [userSign, userKarat] = minter?.balance.numberTuple() || [
            "",
            "Zero"
        ];

        let isSelf = false;
        let balances = "";
        for (const user of users!) {
            if (user.id === this.heartbank.user?.uid) isSelf = true;
            const [sign, karat] = user.balance.numberTuple() || ["", "Zero"];
            balances += `\n\n${getCircle(
                user.balance,
                false
            )} ${user.id === this.heartbank.user?.uid ? "Your" : user.name + "'s"} New Kiitti Balance is ${sign + karat} ${getKiittiSummary(
                user.balance,
                user.id === this.heartbank.user?.uid ? "" : user.name
            )}`;
        }

        const balance = balances
            ? ""
            : `\n\n${getCircle(
                  minter!.balance,
                  false
              )} Your New Kiitti Balance is ${userSign + userKarat} ${getKiittiSummary(
                  minter!.balance
              )}`;

        const aquarius =
            isSelf || balances === ""
                ? "\n\n" + this.aquarius(minter!.balance, false)
                : "";

        const names = this.getNames(users);
        const tags =
            hashtags && hashtags.length > 0
                ? hashtags
                      .map((hashtag) => this.getDearName(hashtag))
                      .joinWithAnd()
                : "";
        const recipients =
            names && tags
                ? `${names} and for ${tags}` // 0 Kiitti: TODO: later more exact depending on number of mentions vs hashtags: see backend
                : names || tags || "Miss Aquarius™";

        // reward
        const reward = minter?.reward || 0;
        const fundReward = Math.floor(reward * REWARD_SHARE);
        const accountReward = reward - fundReward;
        const accountPrize = accountReward
            ? `\n\n🏆 As a reward, Miss Aquarius™ has awarded ${accountReward.toCashAmount3()} to your Personal B-Account!\n\n🧧 Your New B-Account Balance: ${minter?.account.toCashAmount3()}`
            : "";
        const fundPrize = fundReward
            ? `\n\n🏆 As a reward, Miss Aquarius™ has awarded ${fundReward.toCashAmount3()} to your Retip B-Fund!\n\n💰 Your New B-Fund Balance: ${minter?.fund.toCashAmount3()}`
            : "";

        alert(
            `🎉 You have ${
                this.isPrivate ? "privately" : "successfully"
            } captured ${kiitti} Kiitti for ${recipients} as a B-Moment of Kindness!\n\n🌎 ${this.getName(users, hashtags)} kindness is now published on the Aquarius™ Blockchain and broadcasted to inspire the world!${accountPrize + fundPrize}\n\n${getCircle(
                aquaBalance!
            )} Miss Aquarius™'s New Kiitti Balance is ${aquaSign + aquaKarat} ${getKiittiSummary(
                aquaBalance!,
                "Miss Aquarius™"
            )}${balance + balances}${aquarius}`
        );
    }

    // rethank 1 mention
    // kiitos or kiitti // kiitti not used
    private alertSuccess2(
        user: User,
        //isThanker: boolean,
        kiitti: number, // kiitos or kiitti
        isKiitos: boolean,
        fromBalance: number | undefined, // kiitos or kiitti
        //toBalance: number, // kiitos or kiitti
        //toName: string,
        aquaBalance: number | undefined,
        tip: number,
        pool: number
    ) {
        fromBalance = fromBalance || 0;
        const [fromSign, fromKarat] = fromBalance.numberTuple(); //|| ["", "Zero"];

        const balance = isKiitos ? user.balance : aquaBalance || 0;
        const [toSign, toKarat] = balance.numberTuple(); //|| ["", "Zero"];
        const token = isKiitos ? "Kiitos" : "Kiitti";
        const fromSummary = isKiitos
            ? getKiitosSummary(fromBalance || 0)
            : getKiittiSummary(fromBalance || 0);
        const toSummary = isKiitos
            ? getKiitosSummary(balance, user.name)
            : getKiittiSummary(balance, "Miss Aquarius™");

        const gratuity = tip
            ? `and ${user.isThanker ? "donated" : "tipped"} ${(tip + pool).toCashAmount3()} to ${user.name}`
            : `to ${user.name}`;
        const account = tip
            ? user.isThanker
                ? `\n\n💰 ${user.name}'s Retip B-Fund collected ${tip.toCashAmount3()}`
                : `\n\n🧧 ${user.name}'s Personal B-Account received ${tip.toCashAmount3()}`
            : "";
        const fund = pool
            ? user.isThanker
                ? `\n\n♒️ Your Family B-Kitty collected ${pool.toCashAmount3()}`
                : `\n\n💰 ${user.name}'s Retip B-Fund collected ${pool.toCashAmount3()}`
            : "";

        alert(
            `🎉 You have ${
                tip ? "anonymously" : "successfully"
            } re-given ${kiitti} ${token} ${gratuity} as a B-Appreciation!${account + fund}\n\n🌎 ${user.name}'s kindness is now published on the Aquarius™ Blockchain and broadcasted to inspire the world!\n\n${getCircle(
                fromBalance,
                token === "Kiitos"
            )} Your New ${token} Balance is ${fromSign + fromKarat} ${fromSummary}\n\n${getCircle(
                balance,
                token === "Kiitos"
            )} ${isKiitos ? user.name : "Miss Aquarius™"}'s New ${token} Balance is ${toSign + toKarat} ${toSummary}\n\n${this.aquarius(fromBalance, true)}`
        );
    }

    // rethank mentions and tags
    // kiitti for all
    private alertSuccess3(
        isAnonymous: boolean,
        kiitti: number,
        fromBalances: Moment["fromBalances"],
        users: Moment["users"],
        aquaBalance: Moment["aquaBalance"]
    ) {
        const mentions = users
            ?.filter((user) => user.isMention)
            .map((user) => user.name)
            .joinWithAnd();
        const hashtags = users
            ?.filter((user) => !user.isMention)
            .map((user) => user.name)
            .joinWithAnd();

        // from
        const kiittiBalance = fromBalances?.kiitti || 0;
        const kiittiSummary = getKiittiSummary(kiittiBalance);
        const [kiittiSign, kiittiKarat] = kiittiBalance.numberTuple(); //|| ["","Zero"];

        const hasSelf =
            hashtags ||
            users?.some((user) => user.id === this.heartbank.user?.uid);
        const balance = hasSelf
            ? `\n\n${getCircle(
                  kiittiBalance,
                  false
              )} Your New Kiitti Balance is ${kiittiSign + kiittiKarat} ${kiittiSummary}`
            : "";
        const note = hasSelf
            ? `\n\n${this.aquarius(kiittiBalance, false)}`
            : "";

        // to
        let recipients = "";
        let balances = "";
        const people = users?.filter((user) => user.isMention);
        if (people)
            for (const mention of people) {
                recipients += `\n\n💛 You re-gave ${kiitti} Kiitti `;
                recipients += mention.tip
                    ? `and ${mention.isThanker ? "donated" : "tipped"} ${mention.tip.toCashAmount3()}${!mention.isThanker && mention.pool ? ` and donated ${mention.pool.toCashAmount3()}` : ""} to ${mention.name}` +
                      (mention.isThanker && mention.pool
                          ? ` and contributed ${mention.pool.toCashAmount3()} to your Family B-Kitty`
                          : "")
                    : `to ${mention.name}`;

                const kiittiBalance = mention.balance || 0;
                const [sign, karat] = kiittiBalance.numberTuple(); //|| ["", "Zero"];
                balances += `\n\n${getCircle(
                    kiittiBalance,
                    false
                )} ${mention.name}'s New Kiitti Balance is ${sign + karat} ${getKiittiSummary(kiittiBalance, mention.name)}`;
            }

        // aqua
        aquaBalance = aquaBalance || 0;
        const [aquaSign, aquaKarat] = aquaBalance.numberTuple(); //|| ["", "Zero"];
        const aquarius = `\n\n${getCircle(
            aquaBalance
        )} Miss Aquarius™'s New Kiitti Balance is ${aquaSign + aquaKarat} ${getKiittiSummary(
            aquaBalance,
            "Miss Aquarius™"
        )}`;

        const names =
            mentions && hashtags
                ? `${kiitti} Kiitti each to ${hashtags} and the following people as a B-Appreciation:${recipients}`
                : mentions
                  ? `a B-Token of Appreciation to the following people:${recipients}`
                  : `${kiitti} Kiitti each to ${hashtags} as a B-Appreciation!`;

        alert(
            `🎉 You have ${
                isAnonymous ? "anonymously" : "successfully"
            } re-given ${names}\n\n🌎 Their kindness is now published on the Aquarius™ Blockchain and broadcasted to inspire the world!${aquarius}${balances + balance}${note}`
        );
    }

    private alertSuccess3c(
        kiitti: number, // total
        fromBalances: Moment["fromBalances"],
        users: Moment["users"],
        aquaBalance: Moment["aquaBalance"],
        tip: number, // total
        pool: number // total
    ) {
        const mentions = users
            ?.filter((user) => user.isMention)
            .map((user) => user.name)
            .joinWithAnd();
        const hashtags = users
            ?.filter((user) => !user.isMention)
            .map((user) => user.name)
            .joinWithAnd();

        const gratuity = tip ? ` and tipped ${tip.toCashAmount3()}` : "";
        const donation = pool
            ? ` and contributed ${pool.toCashAmount3()} to your Family B-Kitty`
            : "";

        let names = "";
        if (mentions && hashtags) {
            names = `${kiitti} Kiitti${gratuity} to ${mentions} and ${hashtags}`;
        } else if (mentions) {
            names = `${kiitti} Kiitti${gratuity} to ${mentions}`;
        } else if (hashtags) {
            names = `${kiitti} Kiitti${gratuity} to ${hashtags}`;
        }
        names += donation;

        // from
        const kiittiBalance = fromBalances?.kiitti || 0;
        const kiittiSummary = getKiittiSummary(kiittiBalance);
        const [kiittiSign, kiittiKarat] = kiittiBalance.numberTuple(); //|| ["","Zero"];

        const hasSelf =
            hashtags ||
            users?.some((user) => user.id === this.heartbank.user?.uid);
        const balance = hasSelf
            ? `\n\n${getCircle(
                  kiittiBalance,
                  false
              )} Your New Kiitti Balance is ${kiittiSign + kiittiKarat} ${kiittiSummary}`
            : "";
        const note = hasSelf
            ? `\n\n${this.aquarius(kiittiBalance, false)}`
            : "";

        // to
        let balances = "";
        const people = users?.filter((user) => user.isMention);
        if (people)
            for (const mention of people) {
                const kiitti = mention.balance || 0;
                const [sign, karat] = kiitti.numberTuple(); //|| ["", "Zero"];
                balances += `\n\n${getCircle(
                    kiitti,
                    false
                )} ${mention.name}'s New Kiitti Balance is ${sign + karat} ${getKiittiSummary(kiitti, mention.name)}`;
            }

        // aqua
        aquaBalance = aquaBalance || 0;
        const [aquaSign, aquaKarat] = aquaBalance.numberTuple(); //|| ["", "Zero"];
        const aquarius = `\n\n${getCircle(
            aquaBalance
        )} Miss Aquarius™'s New Kiitti Balance is ${aquaSign + aquaKarat} ${getKiittiSummary(
            aquaBalance,
            "Miss Aquarius™"
        )}`;

        alert(
            `🎉 You have ${
                tip ? "anonymously" : "successfully"
            } re-given ${names} as a B-Appreciation!\n\n🌎 Their kindness is now published on the Aquarius™ Blockchain and broadcasted to inspire the world!${aquarius}${balances + balance}${note}`
        );
    }

    // kiitos for mentions // not used // deprecated
    private alertSuccess3b(
        kiitti: number,
        fromBalances: Moment["fromBalances"],
        users: Moment["users"],
        aquaBalance: Moment["aquaBalance"]
    ) {
        const mentions = users
            ?.filter((user) => user.isMention)
            .map((user) => user.name)
            .joinWithAnd();
        const hashtags = users
            ?.filter((user) => !user.isMention)
            .map((user) => user.name)
            .joinWithAnd();

        let names = "";
        if (mentions && hashtags) {
            names = `${kiitti} Kiitos to ${mentions} and ${kiitti} Kiitti to ${hashtags}`;
        } else if (mentions) {
            names = `${kiitti} Kiitos to ${mentions}`;
        } else if (hashtags) {
            names = `${kiitti} Kiitti to ${hashtags}`;
        }

        const kiitosBalance = fromBalances?.kiitos || 0;
        const kiittiBalance = fromBalances?.kiitti || 0;
        const kiitosSummary = getKiitosSummary(kiitosBalance);
        const kiittiSummary = getKiittiSummary(kiittiBalance);

        const [kiitosSign, kiitosKarat] = kiitosBalance.numberTuple(); //|| ["","Zero"];
        const [kiittiSign, kiittiKarat] = kiittiBalance.numberTuple(); //|| ["","Zero"];

        let balances = "";
        if (mentions && hashtags) {
            balances = `${getCircle(
                kiitosBalance,
                true
            )} Your New Kiitos Balance is ${kiitosSign + kiitosKarat} ${kiitosSummary}\n\n${getCircle(
                kiittiBalance,
                false
            )} Your New Kiitti Balance is ${kiittiSign + kiittiKarat} ${kiittiSummary}`;
        } else if (mentions) {
            balances = `${getCircle(
                kiitosBalance,
                true
            )} Your New Kiitos Balance is ${kiitosSign + kiitosKarat} ${kiitosSummary}`;
        } else if (hashtags) {
            balances = `${getCircle(
                kiittiBalance,
                false
            )} Your New Kiitti Balance is ${kiittiSign + kiittiKarat} ${kiittiSummary}`;
        }

        //TODO: later add new balance of recipients

        aquaBalance = aquaBalance || 0;
        const [aquaSign, aquaKarat] = aquaBalance.numberTuple(); //|| ["", "Zero"];
        const aquarius = hashtags
            ? `\n\n${getCircle(
                  aquaBalance
              )} Miss Aquarius™'s New Kiitti Balance is ${aquaSign + aquaKarat} ${getKiittiSummary(
                  aquaBalance,
                  "Miss Aquarius™"
              )}`
            : "";

        alert(
            `🎉 You have ${
                this.isPrivate ? "privately" : "successfully"
            } re-given ${names} as a B-Appreciation!\n\n🌎 Their kindness is now published on the Aquarius™ Blockchain and broadcasted to inspire the world!\n\n${balances}${aquarius}`
        );
    }

    // kiitti
    private aquarius(balance: number, isKiitos: boolean) {
        if (isKiitos) {
            if (balance === 0)
                return "😇 By returning back to Zero, your Aura Color has grown!\n\n♒️ To grow it further, continue to give B-Tokens to people nearby who have touched your heart, and broadcast your location for nearby Zero Heroes to give B-Tokens to you in gratitude.";
            else if (balance < 0)
                return "♒️ Please carry your gratitude forward by showing kindness to people nearby to earn their B-Tokens and return back to Zero!";
            else
                return "♒️ Please carry the gratitude that people nearby have shown to you forward by giving B-Tokens of Appreciation to return back to Zero!";
        } else {
            if (balance === 0)
                return "😇 By returning back to Zero, your Aura Color has grown!\n\n♒️ To grow it further, continue to capture B-Moments of Kindness for Yourself and for Miss Aquarius™.";
            else if (balance < 0)
                return "♒️ Please carry your gratitude forward by capturing your kindness as a B-Moment to return back to Zero!";
            else
                return "♒️ Please carry the gratitude that Miss Aquarius™ has shown to you forward by capturing Miss Aquarius™'s kindness as a B-Moment to return back to Zero!";
        }
    }

    private getCarat() {
        switch (this.thank?.type) {
            case "photo":
                return "Photo";
            case "short":
                return `Short lasting ${Math.round(
                    this.cover.duration
                )} seconds`;
            default:
                return "Kindness Note";
        }
    }

    private isPublic() {
        return (
            !this.thank?.isPrivate ||
            this.thank.user === this.heartbank.user?.uid ||
            this.thank.mentions?.includes(this.heartbank.user?.uid || "")
        );
    }

    // not used
    // kiitos not used here: will use in b-thank later!
    private getOriginalAmount(isKiitos: boolean): number {
        let kiitos = 0,
            kiitti = 0;

        if (this.thank?.rekiitos) {
            for (const [i, k] of this.thank.rekiitos.entries()) {
                if (this.thank?.iskiitos?.[i]) kiitos += k;
                else kiitti += k;
            }
        }

        return isKiitos
            ? (this.thank?.kiitos || 0) - kiitos
            : (this.thank?.kiitti || 0) - kiitti;
    }

    async show(id: string | Moment, isBoost = false) {
        this.showLoading(true);

        if (id && id !== "quest") {
            this.isQuest = false;

            if (typeof id === "string") {
                const moment = await this.kiitti.get(id);
                this.thank = moment.data;
                if (!isBoost && moment.cursor)
                    window.momentCursor = moment.cursor;
            } else {
                this.thank = id;
            }

            if (this.thank) {
                const views = this.views.parentElement
                    ?.lastElementChild as HTMLSpanElement;
                const digs = this.thank.digs || 0;
                const scans = this.thank.scans || 0;
                this.views.textContent = (digs + scans).toString();
                views.textContent =
                    "View" + (this.views.textContent === "1" ? "" : "s");

                this.location.classList.remove("hidden");
                this.location.textContent = this.thank.isPrivate ? "🔒" : "🌎";
                this.location.onclick = () => {
                    if (
                        confirm(
                            `💜 This ${this.thank?.isPrivate ? "private" : "public"} B-Moment was captured on ${this.thank?.date?.toDate().toFormattedString() || "an unknown date"} at ${this.thank?.place || "an unknown place"}\n\n🌎 Would you like to view it on Google Maps?`
                        )
                    ) {
                        const latitude = this.isPublic()
                            ? this.thank?.lat
                            : this.thank?.latitude;
                        const longitude = this.isPublic()
                            ? this.thank?.lng
                            : this.thank?.longitude;
                        window.open(
                            `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`,
                            "_blank"
                        );
                    }
                };

                this.views.classList.remove("hidden");
                this.menu.classList.add("hidden");
                this.archive.classList.add("hidden");
                this.quest.classList.add("hidden");
                this.privacy.classList.add("hidden");
                this.privacy.classList.remove("inline-flex");
                this.checkinForm.classList.add("hidden");

                this.user.innerHTML = `<hb-me class="ml-0" uid="${this.thank.user}"></hb-me>`;
                // this.party.classList.toggle(
                //     "flex-row-reverse",
                //     !this.thank.isSelf
                // );
                this.party.classList.add("inline-flex");
                this.party.classList.remove("hidden");
                //this.arrow.classList.remove("hidden");
                //this.arrowBtn.classList.add("hidden");

                this.resetMenu();
                const menu = this.goldMenu.parentElement as HTMLElement;
                this.cover.muted = !this.cover.poster; // needed to allow autoplay
                if (this.thank.jewel) {
                    this.cover.poster = this.thank.jewel; // this.isPublic() ? this.thank.jewel : hb;
                    this.cover.classList.remove("hidden");
                    menu.classList.remove("-mt-8");
                } else {
                    this.cover.poster = hb;
                    this.cover.classList.remove("hidden");
                    // this.cover.removeAttribute("poster");
                    // this.cover.classList.add("hidden");
                    menu.classList.add("-mt-8");
                }
                if (this.thank.diamond) {
                    this.cover.src = this.isPublic() ? this.thank.diamond : hb;
                    this.cover.controls = true; // needed to clear previous video
                    this.cover.play();

                    this.cover.classList.remove("no-play-button");
                    this.cover.removeAttribute("controlsList");
                    this.cover.style.pointerEvents = "";
                    this.cover.onclick = () => {};
                } else {
                    this.cover.removeAttribute("src");
                    this.cover.controls = false;
                    this.cover.load(); // needed to clear previous video

                    this.cover.classList.add("no-play-button");
                    this.cover.setAttribute(
                        "controlsList",
                        "nodownload nofullscreen noremoteplayback"
                    );
                    this.cover.style.pointerEvents = "none";
                    this.cover.onclick = () => this.cover.pause();
                }

                this.goldMenu.classList.add("hidden");
                this.goldMenu.classList.remove("inline-flex");
                this.goldLabel.classList.remove("hidden");
                this.goldLabel.classList.add("inline-flex");

                const goldTitle = this.goldLabel
                    .firstElementChild as HTMLSpanElement;
                goldTitle.onclick = () => {
                    const kiitti =
                        (this.thank?.kiitos || 0) +
                        (this.thank?.kiitti || 0) -
                        (this.thank?.rekiitos?.reduce((t, i) => t + i) || 0);
                    alert(
                        `♒️ Miss Aquarius™ AI impartially weighs each B-Moment for depth of gratitude and act of kindness and this one equals ${kiitti} Kiitti`
                    );
                };

                this.goldKiitos.textContent =
                    this.thank.kiitos?.toString() || "0";
                const kiitos = this.goldKiitos.parentElement as HTMLSpanElement;
                // kiitos.classList.toggle(
                //     "hidden",
                //     this.goldKiitos.textContent === "0"
                // );
                kiitos.onclick = () =>
                    alert(
                        `♒️ This B-Moment of Kindness received ${this.goldKiitos.textContent} Kiitos in total from people nearby`
                    );

                // TODO: later show total for each person
                this.goldKiitti.textContent =
                    this.thank.kiitti?.toString() || "0";
                const kiitti = this.goldKiitti.parentElement as HTMLSpanElement;
                kiitti.onclick = () =>
                    alert(
                        `💜 This B-Moment of Kindness received ${this.goldKiitti.textContent} Kiitti in total from Miss Aquarius™`
                    );
                // alert(
                //     `💜 This B-Moment of Kindness received ${this.goldKiitos.textContent} Kiitos in total from people nearby and ${this.goldKiitti.textContent} Kiitti in total from everyone else`
                // );

                // TODO: later show total for each person
                const total =
                    (this.thank.tip || 0) +
                    (this.thank.jar || 0) +
                    (this.thank.kitty || 0) +
                    (this.thank.pool || 0);
                const gratuity = this.goldGratuity
                    .parentElement as HTMLSpanElement;
                gratuity.classList.toggle("hidden", !total);
                this.goldGratuity.textContent = total.toCashAmount();
                gratuity.onclick = async () =>
                    alert(
                        `💰 This B-Moment of Kindness collected ${(this.thank?.tip || 0).toCashAmount3()} in total tips, ${(this.thank?.jar || 0).toCashAmount3()} in total gratuities, and ${(this.thank?.kitty || 0).toCashAmount3()} in total donations\n\n♒️ Your Family B-Kitty collected ${(this.thank?.pool || 0).toCashAmount3()} in total contributions`
                    );

                this.gold.value = this.isPublic() ? this.thank.gold : "";
                this.gold.placeholder = this.thank.isPrivate
                    ? "Private Kindness Note"
                    : "I'm thankful for the gift of life.";
                // this.gold.placeholder = this.thank.isSelf
                //     ? "I'm thankful for myself."
                //     : "I'm thankful for the gift of life.";
                this.gold.disabled = true;
                this.gold.classList.add(
                    "text-center",
                    "leading-loose",
                    "font-cursive",
                    "text-2xl",
                    "h-56"
                );
                this.gold.classList.remove("text-lg", "h-40");

                this.footerDate.textContent =
                    "Captured on " +
                        this.thank.date?.toDate().toFormattedString() || "";
                this.footer.classList.remove("hidden");

                this.goldKarat.textContent =
                    this.thank.karat?.toString() || "0";
                const karat = this.goldKarat.parentElement as HTMLSpanElement;
                karat.onclick = () =>
                    alert(
                        `💜 This B-Moment has ${
                            this.goldKarat.textContent
                        } word${
                            this.goldKarat.textContent === "1" ? "" : "s"
                        } in total`
                    );

                this.goldCarat.textContent =
                    this.thank.carat?.toString() || "0";
                const carat = this.goldCarat.parentElement as HTMLSpanElement;
                carat.onclick = () =>
                    alert(`💜 This B-Moment has a ${this.getCarat()}`);

                this.rethanks.textContent =
                    this.thank.rethankers?.length.toString() || "0";
                const rethanks = this.rethanks.parentElement as HTMLSpanElement;
                const rethanksText =
                    rethanks.lastElementChild as HTMLSpanElement;
                rethanksText.textContent =
                    "Re-thank" + (this.rethanks.textContent === "1" ? "" : "s");
                rethanks.onclick = async () => {
                    rethanks.style.opacity = "0.5";
                    let text = "";

                    if (
                        this.thank?.rethankers &&
                        this.thank.rethankers.length > 0
                    ) {
                        for (const [
                            index,
                            uid
                        ] of this.thank.rethankers.entries()) {
                            const isThank =
                                this.thank.isthanks?.[index] || false;
                            const tip = this.thank.retips?.[index] || 0;
                            const pool = this.thank.repools?.[index] || 0;

                            const minter = await this.me.getUserProfile(uid);
                            const minterName = tip
                                ? this.heartbank.user?.uid === uid
                                    ? "YOU as Someone"
                                    : "Someone"
                                : this.me.getName2(minter);

                            if (this.thank.ismentions?.[index]) {
                                const iskiitos = this.thank.iskiitos?.[index];
                                const token = iskiitos ? "Kiitos" : "Kiitti";
                                const nearby = iskiitos ? " who's nearby" : "";

                                const minterBalance = iskiitos
                                    ? minter.kiitos || 0
                                    : minter.kiitti || 0;
                                const [minterSign, minterKarat] =
                                    minterBalance.numberTuple();

                                const minerID = this.thank.rementions?.[index]!;
                                const miner =
                                    await this.me.getUserProfile(minerID);
                                const minerName =
                                    this.heartbank.user?.uid === minerID
                                        ? "YOU"
                                        : this.me.getName2(miner);
                                const minerBalance = iskiitos
                                    ? miner.kiitos || 0
                                    : miner.kiitti || 0;
                                const [minerSign, minerKarat] =
                                    minerBalance.numberTuple();

                                const gratuity = tip
                                    ? ` and ${isThank ? "donated" : "tipped"} ${tip.toCashAmount3()}${!isThank && pool ? ` and donated ${pool.toCashAmount3()}` : ""} to ${minerName}` +
                                      (isThank && pool
                                          ? ` and contributed ${pool.toCashAmount3()} to your Family B-Kitty`
                                          : "")
                                    : ` to ${minerName}`;

                                text += `\n\n🟪 ${minterName + nearby} re-gave ${this.thank.rekiitos?.[index]} ${token + gratuity} on ${this.thank.redates?.[index].toDate().toFormattedString()}\n\n${getCircle(
                                    minterBalance,
                                    true
                                )} ${minterName}'s current ${token} Balance is ${minterSign + minterKarat} ${getKiitosSummary(minterBalance, minterName)}\n\n${getCircle(
                                    minerBalance,
                                    true
                                )} ${minerName}'s current ${token} Balance is ${minerSign + minerKarat} ${getKiitosSummary(minerBalance, minerName)}`;
                            } else {
                                const [sign, karat] =
                                    minter.kiitti.numberTuple() || ["", "Zero"];

                                const minerName = this.getDearName(
                                    this.thank.rementions?.[index]!
                                );

                                text += `\n\n🟪 ${minterName} re-gave ${this.thank.rekiitos?.[index]} Kiitti to ${minerName} on ${this.thank.redates?.[index].toDate().toFormattedString()}\n\n${getCircle(
                                    minter.kiitti || 0,
                                    false
                                )} ${minterName}'s current Kiitti Balance is ${sign + karat} ${getKiittiSummary(minter.kiitti || 0, minterName)}`;
                            }
                        }
                    }

                    const name = "Miss Aquarius™";
                    const kiitti = await this.kiitti.getKiitti();
                    const [sign, karat] = kiitti.numberTuple() || ["", "Zero"];
                    const footer = this.thank?.iskiitos?.includes(false)
                        ? `\n\n${getCircle(
                              kiitti || 0,
                              false
                          )} ${name}'s current Kiitti Balance is ${sign + karat} ${getKiittiSummary(kiitti || 0, name)}`
                        : "";
                    const total = this.thank?.rethankers?.length || 0;

                    alert(
                        total
                            ? `💜 This B-Moment of Kindness has ${total} Re-Thanker${total === 1 ? "" : "s"}:${text}${footer}`
                            : `💜 This B-Moment of Kindness has no Re-Thankers for ${name}`
                    );
                    rethanks.style.opacity = "";
                };

                //this.internalBtns.classList.add("hidden");
                this.captureBtn.classList.add("hidden");
                this.captureNewBtn.classList.remove("hidden");
                this.externalBtns.classList.remove("hidden");
                this.thankBtns.classList.remove("hidden");
                this.tokenBtns.classList.add("hidden");
                //if (this.thankBtns.childElementCount === 0) // bc can only thank 1 time
                await this.renderThanks();
                if (this.tokenBtns.childElementCount === 0)
                    await this.renderTokens();

                // stats
                this.kiitti.addMiner(
                    this.heartbank.user?.uid || "",
                    this.thank.id!
                );
            } else window.location.hash = "#/aquarius";
        } else {
            this.isQuest = id === "quest";
            this.thank = null;

            this.menu.classList.remove("hidden");
            this.archive.classList.toggle("hidden", this.isQuest);
            this.quest.classList.toggle("hidden", !this.isQuest);
            this.privacy.classList.remove("hidden");
            this.privacy.classList.add("inline-flex");
            this.publicBtn.click();
            this.location.classList.add("hidden");

            this.checkinForm.classList.remove("hidden");
            if (this.checkinOrgs.childElementCount === 0)
                await this.renderCheckin(false);
            // if (
            //     this.checkinOrgs.childElementCount === 0 ||
            //     this.cachedLocation !== window.earth.cachedLocation
            // ) {
            //     await this.renderCheckin(true); // need if so that user previous selection is retained // violation when page loads on hb-ship bc need click event
            //     this.cachedLocation = window.earth.cachedLocation;
            // }

            this.user.innerHTML = `<hb-me class="ml-0" uid="${this.heartbank.user?.uid || ""}"></hb-me>`;
            //this.party.classList.toggle("flex-row-reverse", !this.isSelf);
            this.party.classList.remove("inline-flex");
            this.party.classList.add("hidden");
            //this.party.classList.toggle("hidden", !this.heartbank.user);
            //this.party.classList.toggle("inline-flex", !!this.heartbank.user);
            //this.arrow.classList.add("hidden");
            //this.arrowBtn.classList.remove("hidden");

            const photo = localStorage.getItem("moment-photo");
            if (photo) {
                this.photoImage.src = photo;
                this.photoImageContainer.classList.remove("hidden");
                this.photoUpload.classList.add("hidden");
            } else {
                this.photoImage.removeAttribute("src");
            }

            const poster = localStorage.getItem("moment-poster");
            const short = localStorage.getItem("moment-short");
            if (poster || short) {
                if (poster) this.shortVideo.poster = poster;
                if (short) this.shortVideo.src = short;
                this.shortVideo.controls = true;
                this.shortVideoContainer.classList.remove("hidden");
                this.shortUpload.classList.add("hidden");
            } else {
                this.shortVideo.removeAttribute("poster");
                this.shortVideo.removeAttribute("src");
            }

            //this.photoBtn.click();
            this.shortBtn.click();
            this.cover.classList.add("hidden");

            const menu = this.goldMenu.parentElement as HTMLElement;
            menu.classList.remove("-mt-8");
            this.goldMenu.classList.remove("hidden");
            this.goldMenu.classList.add("inline-flex");
            this.goldLabel.classList.add("hidden");
            this.goldLabel.classList.remove("inline-flex");

            this.gold.value = localStorage.getItem("moment-gold") || "";
            this.renderGold();
            this.gold.disabled = false;
            this.gold.classList.remove(
                "text-center",
                "leading-loose",
                "font-cursive",
                "text-2xl",
                "h-56"
            );
            this.gold.classList.add("text-lg", "h-40");

            this.footer.classList.add("hidden");
            //this.internalBtns.classList.remove("hidden");
            this.captureBtn.classList.remove("hidden");
            this.captureNewBtn.classList.add("hidden");
            this.externalBtns.classList.add("hidden");
            this.thankBtns.classList.add("hidden");
            this.tokenBtns.classList.add("hidden");
        }

        this.internalBtns.classList.remove("hidden");
        this.heroes.classList.add("hidden");
        this.footerRecommended.classList.add("hidden");
        this.modal.show();
        this.showLoading(false);
    }

    private hasReThanked(mention: string) {
        if (this.heartbank.user?.uid && this.thank?.rethankers)
            for (const [index, rethanker] of this.thank.rethankers.entries()) {
                if (rethanker === this.heartbank.user.uid)
                    if (
                        this.thank.rementions &&
                        this.thank.rementions[index] === mention
                    )
                        return true;
            }

        return false;
    }

    // always include content creator
    private getInitialTotal(): number {
        return this.thank?.user === this.heartbank.user?.uid ||
            this.hasReThanked(this.thank?.user!)
            ? 0
            : 1;
    }

    private getTotal(): number {
        let total = 0;

        if (this.thank?.mentions?.length)
            for (const mention of this.thank.mentions)
                if (
                    this.thank.user !== mention &&
                    this.heartbank.user?.uid !== mention &&
                    !this.hasReThanked(mention)
                )
                    total += 1;

        return this.getInitialTotal() + total;
    }

    private async renderThanks() {
        let total = this.getInitialTotal();
        this.thankBtns.innerHTML = "";

        // rethank mentions
        if (this.thank?.mentions?.length)
            for (const mention of this.thank.mentions) {
                if (
                    //this.thank.user !== mention &&
                    this.heartbank.user?.uid !== mention &&
                    !this.hasReThanked(mention)
                ) {
                    const button = document.createElement("button");
                    button.type = "button";
                    button.className = `text-white bg-purple-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-base w-full px-5 py-2.5 text-center`;
                    button.innerHTML = `Re-Thank <strong>${await this.me.getName3(mention)}</strong>`;

                    button.onclick = async () => {
                        this.selectedMention = mention;
                        this.selectedHashTag = "";
                        await this.renderTokens();
                        this.externalBtns.classList.add("hidden");
                        this.internalBtns.classList.add("hidden");
                        this.thankBtns.classList.add("hidden");
                        this.tokenBtns.classList.remove("hidden");
                        this.dear.scrollTo({
                            top: this.dear.scrollHeight,
                            behavior: "smooth"
                        });
                    };

                    this.thankBtns.appendChild(button);
                    if (this.thank.user !== mention) total += 1;
                }
            }

        // rethank hashtags
        if (this.thank?.hashtags?.length)
            for (const hashtag of this.thank.hashtags) {
                if (
                    this.thank?.user !== this.heartbank.user?.uid &&
                    !this.hasReThanked(hashtag)
                ) {
                    const button = document.createElement("button");
                    button.type = "button";
                    button.className = `text-white bg-purple-800 focus:ring-4 focus:outline-none font-medium rounded-lg text-base w-full px-5 py-2.5 text-center`;
                    button.innerHTML = `Re-Thank <strong>${this.getDearName(hashtag)}</strong>`;

                    button.onclick = async () => {
                        this.selectedMention = "";
                        this.selectedHashTag = hashtag;
                        await this.renderTokens();
                        this.externalBtns.classList.add("hidden");
                        this.internalBtns.classList.add("hidden");
                        this.thankBtns.classList.add("hidden");
                        this.tokenBtns.classList.remove("hidden");
                        this.dear.scrollTo({
                            top: this.dear.scrollHeight,
                            behavior: "smooth"
                        });
                    };

                    this.thankBtns.appendChild(button);
                    total += 1;
                }
            }

        // thank content creator
        if (
            this.thank?.user &&
            this.thank.user !== this.heartbank.user?.uid &&
            !this.thank.mentions?.includes(this.thank.user) &&
            !this.hasReThanked(this.thank.user)
        ) {
            const button = document.createElement("button");
            button.type = "button";
            button.className = `text-white bg-purple-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-base w-full px-5 py-2.5 text-center`;
            button.innerHTML = `Thank <strong>${await this.me.getName3(this.thank.user)}</strong>`;

            button.onclick = async () => {
                this.selectedMention = this.thank?.user!;
                this.selectedHashTag = "";
                await this.renderTokens();
                this.externalBtns.classList.add("hidden");
                this.internalBtns.classList.add("hidden");
                this.thankBtns.classList.add("hidden");
                this.tokenBtns.classList.remove("hidden");
                this.dear.scrollTo({
                    top: this.dear.scrollHeight,
                    behavior: "smooth"
                });
            };

            this.thankBtns.prepend(button);
        }

        // re-thank all
        if (total > 1) {
            const button = document.createElement("button");
            button.type = "button";
            button.className = `text-white bg-purple-900 focus:ring-4 focus:outline-none font-medium rounded-lg text-base w-full px-5 py-2.5 text-center`;
            button.innerHTML = `Re-Thank <strong>ALL</strong>`;

            button.onclick = async () => {
                this.selectedMention = "";
                this.selectedHashTag = "";
                await this.renderTokens();
                this.externalBtns.classList.add("hidden");
                this.internalBtns.classList.add("hidden");
                this.thankBtns.classList.add("hidden");
                this.tokenBtns.classList.remove("hidden");
                this.dear.scrollTo({
                    top: this.dear.scrollHeight,
                    behavior: "smooth"
                });
            };

            this.thankBtns.appendChild(button);
        }

        // thank aquarius
        if (this.thankBtns.innerHTML === "") {
            if (
                this.thank?.mentions?.length ||
                this.thank?.hashtags?.length ||
                this.thank?.user === this.heartbank.user?.uid ||
                this.hasReThanked("Aquarius")
            ) {
                this.thankBtns.classList.add("hidden");
                this.internalBtns.classList.remove("hidden");
                this.captureBtn.classList.add("hidden");
                this.captureNewBtn.classList.remove("hidden");
            } else {
                const button = document.createElement("button");
                button.type = "button";
                button.className = `text-white bg-purple-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-base w-full px-5 py-2.5 text-center`;
                button.innerHTML = `Thank <strong>Miss Aquarius™</strong>`;

                button.onclick = async () => {
                    this.selectedMention = "";
                    this.selectedHashTag = "Aquarius";
                    await this.renderTokens();
                    this.externalBtns.classList.add("hidden");
                    this.internalBtns.classList.add("hidden");
                    this.thankBtns.classList.add("hidden");
                    this.tokenBtns.classList.remove("hidden");
                    this.dear.scrollTo({
                        top: this.dear.scrollHeight,
                        behavior: "smooth"
                    });
                };

                this.thankBtns.appendChild(button);
                this.thankBtns.classList.remove("hidden");
                this.internalBtns.classList.remove("hidden");
                this.captureBtn.classList.add("hidden");
                this.captureNewBtn.classList.remove("hidden");
            }
        }
    }

    private getDearName(hashtag: string) {
        const agent = Dear.find(
            (item) => item.hashtag.toLowerCase() === hashtag.toLowerCase()
        );
        return agent ? agent.name : "#" + hashtag;
    }

    private async renderTokens() {
        this.tokenBtns.innerHTML = "";

        // cancel
        const button = document.createElement("button");
        button.type = "button";
        button.className = `text-white bg-purple-900 focus:ring-4 focus:outline-none font-medium rounded-lg text-base w-full px-5 py-2.5 text-center`;
        button.innerHTML = `Cancel`;
        button.onclick = () => {
            this.externalBtns.classList.remove("hidden");
            this.internalBtns.classList.remove("hidden");
            this.thankBtns.classList.remove("hidden");
            this.tokenBtns.classList.add("hidden");
        };
        this.tokenBtns.appendChild(button);

        const profile = this.selectedMention
            ? await this.me.getUserProfile(this.selectedMention)
            : null;

        const name = this.selectedMention
            ? this.me.getName2(profile) // await this.me.getName3(this.selectedMention)
            : this.selectedHashTag
              ? this.getDearName(this.selectedHashTag)
              : this.selectedHashTag === "Aquarius"
                ? "Miss Aquarius™"
                : "ALL";

        const isSenderReThank = this.heartbank.user?.uid === this.thank?.user;

        for (const token of TOKENS) {
            const button = document.createElement("button");
            button.type = "button";
            //button.dataset.token = token.token;
            button.className = `text-white ${token.color} focus:ring-4 focus:outline-none font-medium rounded-lg text-base w-full px-5 py-2.5 text-center`;
            //button.innerHTML = `Give ${token.emoji} ${this.selectedMention ? "Kiitos" : "Kiitti"} to <strong>${name}</strong>`;
            button.innerHTML = `Give ${token.emoji} ${isSenderReThank ? "B-Tip" : "Kiitti"} to <strong>${name}</strong>`;

            button.onclick = async () => {
                this.showLoading(true);
                button.disabled = true;
                if (this.heartbank.user && this.hasPasskey) {
                    const tip = profile
                        ? isSenderReThank
                            ? getTipAmount(
                                  "retip",
                                  true,
                                  this.thank?.user === this.selectedMention,
                                  true,
                                  profile,
                                  name,
                                  token.token,
                                  this.thank?.kiitti || this.thank?.kiitos || 0,
                                  true,
                                  false
                              )
                            : getTipAmount2(
                                  this.thank?.user === this.selectedMention,
                                  true,
                                  profile,
                                  name,
                                  token.token,
                                  this.thank?.kiitos || 0,
                                  this.thank?.kiitti || 0
                              )
                        : name === "ALL"
                          ? getTipAmount3(
                                this.getTotal(),
                                token.token,
                                this.thank?.kiitos || 0,
                                this.thank?.kiitti || 0
                            )
                          : 0;

                    if ((!isSenderReThank && tip !== -1) || tip > 0) {
                        const response = await this.kiitti.rethank(
                            this.heartbank.user.uid,
                            this.thank?.id!,
                            this.selectedMention,
                            this.selectedHashTag,
                            token.token,
                            tip
                        );
                        if (response.data) {
                            this.isPrivate = response.data.isPrivate;
                            const index = response.data.rethankers!.lastIndexOf(
                                this.heartbank.user.uid
                            );
                            const kiitti = response.data.rekiitos![index];
                            const iskiitos = response.data.iskiitos![index];
                            const tip2 = response.data.retips![index];
                            const pool = response.data.repools![index];

                            if (this.selectedMention) {
                                const user = response.data.users![0];
                                this.alertSuccess2(
                                    user,
                                    //user.isThanker,
                                    kiitti,
                                    iskiitos,
                                    iskiitos
                                        ? response.data.fromBalances?.kiitos
                                        : response.data.fromBalances?.kiitti,
                                    //user.balance,
                                    //user.name,
                                    response.data.aquaBalance,
                                    tip2,
                                    pool
                                );
                                // } else if (response.data.users?.length === 1) {
                                //     const user = response.data.users[0];
                                //     this.alertSuccess2(
                                //         kiitti,
                                //         false,
                                //         response.data.fromBalances?.kiitti,
                                //         user.balance,
                                //         user.name,
                                //         response.data.aquaBalance
                                //     );
                            } else {
                                // const total =
                                //     response.data.users?.filter(
                                //         (user) => user.isMention
                                //     ).length || 0;

                                this.alertSuccess3(
                                    !!tip,
                                    kiitti, // * total, // assuming same amount for each person
                                    response.data.fromBalances,
                                    response.data.users,
                                    response.data.aquaBalance
                                    // * total,
                                    // * total
                                );
                            }

                            const event = new CustomEvent("hb-treasury", {
                                detail: {
                                    isShow: false
                                },
                                bubbles: true,
                                composed: true
                            });
                            this.dispatchEvent(event);

                            await this.show(response.data.id!);
                        } else if (response.color === "red")
                            alert(response.text);
                    }
                } else {
                    if (this.heartbank.user) {
                        if (
                            confirm(
                                `Passkey is required to re-thank ${name}\n\nWould you like to create one now?`
                            )
                        ) {
                            localStorage.setItem(
                                "redirect-lockbox",
                                window.location.hash
                            );
                            window.location.hash = "#/lockbox";
                        }
                    } else {
                        if (
                            confirm(
                                `You need to be logged in to re-thank ${name}\n\nWould you like to log in now?`
                            )
                        ) {
                            localStorage.setItem(
                                "redirect-login",
                                window.location.hash
                            );
                            window.location.hash = "#/login";
                        }
                    }
                }
                button.disabled = false;
                this.showLoading(false);
            };

            this.tokenBtns.appendChild(button);
        }
    }

    private hasMedia() {
        const photo = localStorage.getItem("moment-photo");
        const short = localStorage.getItem("moment-short");
        return photo || short;
    }

    private renderGold() {
        this.gold.required = !this.hasMedia();
        this.gold.placeholder = `${this.hasMedia() ? "Optional" : "Required"}: Include a Kindness Note here for Miss Aquarius™ AI to weigh\n\nYou can #tag or @mention anyone, including yourself!\n\nMiss Aquarius™ will receive Kiitti from you for each #tag and will give Kiitti back to each @mention in gratitude\n\nTo decide for yourself how much Kiitti to give to Miss Aquarius™, use 💜 followed by the amount\n\nYour B-Moment will be ${this.isPrivate ? "privately" : "publicly"} stored forever on the Aquarius™ Blockchain`;
        //this.gold.placeholder = `${this.hasMedia() ? "Optional" : "Required"}: Include a Kindness Note to ${this.isSelf ? "Yourself" : "Life"} for Miss Aquarius™ AI to weigh\n\nYour B-Moment will be ${this.isPrivate ? "privately" : "publicly"} stored forever on the Aquarius™ Blockchain`; // based on context and effort
    }

    hide() {
        this.modal.hide();
    }

    private getUrl() {
        return `${B}/m/${this.thank!.id}`;
    }

    private async getText(isShare: boolean) {
        if (this.thank?.rethankers && this.thank.rethankers.length > 0)
            return "";
        else {
            const sender = await this.me.getName3(this.thank?.user!);

            const to = [];
            if (this.thank?.mentions) {
                for (const uid of this.thank.mentions) {
                    const name = await this.me.getName3(uid);
                    to.push(name);
                }
            }
            if (this.thank?.hashtags) {
                for (const hashtag of this.thank.hashtags) {
                    to.push(this.getDearName(hashtag));
                }
            }

            const gold = this.thank?.gold ? this.thank.gold + "\n\n" : "";
            const url = isShare ? "" : this.getUrl() + "\n\n";
            const url2 = isShare ? "" : this.getUrl();

            const header = gold ? "💜 Dear Miss Aquarius™\n\n" : "";
            // const header = this.thank?.isSelf
            //     ? "💜 HeartBank® Moment of Kindness\n\n"
            //     : "💜 Dear Miss Aquarius™\n\n";
            const footer = to.length
                ? `💝 If this kindness moves your heart too, tap on the link to re-thank ${to.joinWithAnd()}!`
                : `💜 If this kindness moves your heart too, tap on the link to re-thank ${sender} or Miss Aquarius™`;
            //: "♒️ Tap on the link if you want to play the Zero-Point Game ℠ by Miss Aquarius™ AI too!";

            return this.isPublic() ? header + gold + url + footer : url2;
            //return gold && this.isPublic() ? header + gold + url + footer : url2;
        }
    }

    private async share(event: Event) {
        event.preventDefault();
        this.shareBtn.disabled = true;

        const shareData = {
            title: "HeartBank® Moment",
            text: await this.getText(true),
            url: this.getUrl(),
            files: []
        };
        //console.log(shareData);

        if (navigator.canShare && navigator.canShare(shareData)) {
            try {
                await navigator.share(shareData);
                console.log("Shared successfully");
            } catch (error: any) {
                if (
                    error.name === "AbortError" ||
                    error.name === "InvalidStateError"
                ) {
                    console.warn("Sharing was cancelled:", error);
                } else {
                    console.error(error);
                }
            }
        } else {
            alert("Sorry, Web Share is not supported on this device.");
        }

        this.shareBtn.disabled = false;
    }

    private async renderCheckin(isReset: boolean) {
        //TODO: render crews

        // render orgs
        this.checkinOrgs.innerHTML = "";
        const places = await window.earth.getNearbyPlaces(isReset);
        if (places.length > 0) {
            const place = places[0]; // default location: current city
            const option = document.createElement("option");
            option.value = "0";
            option.dataset.lat = place.lat.toString();
            option.dataset.lng = place.lng.toString();
            option.dataset.address = place.formattedAddress;
            option.dataset.region =
                place.locality === place.region
                    ? place.locality
                    : `${place.locality}, ${place.region}`;
            option.dataset.country = place.country;
            option.text = option.dataset.region;
            this.checkinOrgs.appendChild(option);

            for (const place of places) {
                const option = document.createElement("option");
                option.value = place.id;
                option.dataset.lat = place.lat.toString();
                option.dataset.lng = place.lng.toString();
                option.dataset.address = place.formattedAddress;
                option.dataset.region =
                    place.locality === place.region
                        ? place.locality
                        : `${place.locality}, ${place.region}`;
                option.dataset.country = place.country;
                option.text = place.displayName.truncate2(25);
                this.checkinOrgs.appendChild(option);

                dear.unshift({
                    name: place.displayName,
                    hashtag: this.pascalCase(place.displayName)
                });
            }

            dear.unshift({
                name: option.text,
                hashtag: this.pascalCase(option.text)
            });
        } else {
            const option = document.createElement("option");
            option.value = "0";
            option.dataset.lat = window.earth.longBeach.lat.toString();
            option.dataset.lng = window.earth.longBeach.lng.toString();
            option.dataset.address = window.earth.longBeach.address;
            option.dataset.region = window.earth.longBeach.region;
            option.dataset.country = window.earth.longBeach.country;
            option.text = option.dataset.region;
            this.checkinOrgs.appendChild(option);

            dear.unshift({
                name: option.text,
                hashtag: this.pascalCase(option.text)
            });
        }
    }

    private pascalCase(input: string): string {
        return input
            .replace(/[^a-zA-Z0-9\s]/g, "") // keep only alphanumeric + spaces
            .trim()
            .split(/\s+/)
            .filter(Boolean)
            .map(
                (word) =>
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join("");
    }

    private getKind() {
        const kind = this.querySelector<HTMLInputElement>(
            "input[name=hb-dear-checkin]:checked"
        );
        return kind?.value as Moment["group"];
    }
}
